import script from "./Viewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Viewer.vue?vue&type=script&setup=true&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=17781ed2&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17781ed2"]])

export default __exports__